import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["banner"]

  acceptAll() {
    this.#setConsent("all")
  }

  rejectAll() {
    this.#setConsent("essential")
  }

  #setConsent(value) {
    const oneYear = 365 * 24 * 60 * 60
    document.cookie = `cookie_consent=${value}; path=/; max-age=${oneYear}; SameSite=Lax`
    this.bannerTarget.remove()
    if (value === "all") {
      window.dispatchEvent(new CustomEvent("cookies:accepted"))
    }
  }
}
